import React, { useState } from 'react';
import ErrorValidator from '../../ErrorValidator';
import DeleteIcon from '../../assets/images-new/icons/bin-icon.svg';
import TickIcon from "../../images/tick.svg";

const Link = (props) => {
  const data = props.data
  const _ = require('lodash');
  //Style error
  const errorStyle = { color: "red", fontSize: "10px" };

  const updateLink = (input) => {
    props.saveAction({ [props.id]: { ...data, ...input } })
  }
  const [checkField, setCheckField] = useState('');

  const fieldFocus = (e) => {
    setCheckField(e.target.name);
    removeError(e.target.name, props.id);
    props.saveAction({ [props.id]: { ...data, validated: false } })
  }

  const nrFieldFocus = e => {
    setCheckField(e.target.name);
  }

  const nrFieldBlur = e => {
    setCheckField('');
  }

  const fieldBlur = (e) => {
    setCheckField('');
    let v = {}
    if (!props.validatatorObj.hasOwnProperty(props.id)) props.validatatorObj[props.id] = new ErrorValidator(props.validatorsSet2)
    const er = props.validatatorObj[props.id].validateFields(e.target.value, e.target.name)
    if (Object.keys(er).length) {
      v[props.id] = er
      props.setError({ ...props.error, ...v })
    }
    if (!Object.keys(v).length) {
      props.saveAction({ [props.id]: { ...data, validated: true } })
      removeError(e.target.name, props.id);
    }
  }

  const deleteSocialLink = (id) => {
    props.setError({ ...props.error, [id]: '' });
    props.deleteAction(id);
  }
  const showMarker = (field) => {
    return (data.hasOwnProperty(field) && data[field].length && data.hasOwnProperty('validated') && data['validated'])
  };


  const removeError = (field, id) => {
    if (props.error.hasOwnProperty(id) && props.error[id].hasOwnProperty(field)) {
      //remove for whole set, has two use cases
      let e = { ...props.error }
      if (Object.keys(e[id]).length == 1) delete e[id]
      else delete e[id][field]
      props.setError({ ...e })
    }
  }
  return (
    <div className="form-row column-2">
      <div className="field-wrap">
        {/* <label htmlFor="SocialWebsite" className={`label${checkField == 'label' ? ' label-focus': '' }`}>
        Description (optional)
        </label> */}
        <input
          placeholder="Description (optional)"
          type="text"
          className=""
          name="label"
          value={data.label}
          onChange={(e) => updateLink({ label: e.target.value })}
          onFocus={(e) => fieldFocus(e)}
          onBlur={(e) => fieldBlur(e)}
        />
      </div>
      <div className="field-wrap">
        {/* <label htmlFor="SocialLink" className={`label${checkField == 'link' ? ' label-focus': '' }`}>
        Link/Text/Etc.
        </label> */}
        <input
          placeholder="Link/Text/Etc."
          type="text"
          className="validated"
          name="link"
          value={data.link}
          onChange={(e) => updateLink({ link: e.target.value })}
          onFocus={(e) => fieldFocus(e)}
          onBlur={(e) => fieldBlur(e)}
        />

      </div>
      <button
        className="btn btn-link delete-link"
        onClick={(e) => deleteSocialLink(props.id)}
      >
        <DeleteIcon />
      </button>
    </div>

  );
};

export default Link;

{/* <div className="block-inputs row">
      <div className="pre-input pre-input__half-l no-change-mobile">
          <div className={`full-width-input label-shift ${checkField == 'label' ? 'is-focus' : ''} ${data.label.length ? 'is-filled' : ''}`}>
            <input
              type="text"
            className="form-input"
              name="label"
              value={data.label}
              onChange={(e) => updateLink({ label: e.target.value })}
            onFocus={(e) => fieldFocus(e)}
            onBlur={(e) => fieldBlur(e)}
            />
            <label htmlFor="SocialWebsite" className="label">
              Label
            </label>
        </div>
        {showMarker("label") ? (
          <div className="validate-tick">
            <TickIcon />
          </div>
        ) : (
          ""
        )}
        {props.error[props.id] && (
            <span style={errorStyle}>
              {props.error[props.id].label}
            </span>
        )}
      </div>

      <div className="pre-input pre-input__half-r delete-row">
        <div className={`full-width-input label-shift ${checkField == 'link' ? 'is-focus' : ''} ${data.link.length ? 'is-filled' : ''}`}>
          <input
            type="text"
            className="form-input validated"
            name="link"
            value={data.link}
            onChange={(e) => updateLink({ link: e.target.value })}
            onFocus={(e) => fieldFocus(e)}
            onBlur={(e) => fieldBlur(e)}
          />
          <label htmlFor="SocialLink" className="label">
            Link
          </label>
        </div>
        {!props.error[props.id] && showMarker("link") ? (
          <div className="validate-tick">
            <TickIcon />
          </div>
        ) : (
          ""
        )}
        {props.error[props.id] && (
            <span style={errorStyle}>
              {props.error[props.id].link}
            </span>
          )}
      </div>
      <div className="icon-wrap">
        <button
          className="btn btn-link"
          onClick={(e) => deleteSocialLink(props.id)}
        >
          <DeleteIcon />
        </button>
      </div>
    </div> */}